import { render, staticRenderFns } from "./Special_detail.vue?vue&type=template&id=dc5e7550&scoped=true&"
import script from "./Special_detail.vue?vue&type=script&lang=js&"
export * from "./Special_detail.vue?vue&type=script&lang=js&"
import style0 from "./Special_detail.vue?vue&type=style&index=0&id=dc5e7550&scoped=true&lang=css&"
import style1 from "./Special_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e7550",
  null
  
)

export default component.exports